"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignEventTypes = void 0;
var CampaignEventTypes;
(function (CampaignEventTypes) {
    CampaignEventTypes["InviteSent"] = "invite_sent";
    CampaignEventTypes["AcceptedInvite"] = "accepted_invite";
    CampaignEventTypes["InfluencerUpdated"] = "influencer_updated";
    CampaignEventTypes["LinkSent"] = "link_sent";
    CampaignEventTypes["ContentSent"] = "content_sent";
    CampaignEventTypes["ContentStatusUpdated"] = "content_status_updated";
    CampaignEventTypes["PaymentSent"] = "payment_sent";
    CampaignEventTypes["AgreementSent"] = "agreement_sent";
    CampaignEventTypes["AgreementSigned"] = "agreement_signed";
    CampaignEventTypes["PaymentFailed"] = "payment_failed";
    CampaignEventTypes["PaymentSucceeded"] = "payment_succeeded";
    CampaignEventTypes["CouponSent"] = "coupon_sent";
    CampaignEventTypes["ShopConversion"] = "shop_conversion";
    CampaignEventTypes["PersonalDetailsUpdated"] = "updated_personal_details";
    CampaignEventTypes["ProductGiftingOrderApproved"] = "product_gifting_order_approved";
    CampaignEventTypes["ProductGiftingOrderDeclined"] = "product_gifting_order_declined";
    CampaignEventTypes["ProductGiftingOrderReset"] = "product_gifting_order_reset";
    CampaignEventTypes["ProductGiftingOrderRequested"] = "product_gifting_order_requested";
    CampaignEventTypes["ProductGiftingOrderFulfilled"] = "product_gifting_order_fulfilled";
})(CampaignEventTypes = exports.CampaignEventTypes || (exports.CampaignEventTypes = {}));
//# sourceMappingURL=campaignEventTypes.enum.js.map